import { render, staticRenderFns } from "./ScreeningSingleCreate.vue?vue&type=template&id=4b56cb73&scoped=true&"
import script from "./ScreeningSingleCreate.vue?vue&type=script&lang=js&"
export * from "./ScreeningSingleCreate.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningSingleCreate.vue?vue&type=style&index=0&id=4b56cb73&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b56cb73",
  null
  
)

export default component.exports